import axios from 'axios'

export default async function fetchData(url, onSuccess, context, config = {}) {
  try {
    const response = await axios.get(url, config)

    if (response.data.status === 'success') {
      if (typeof onSuccess === 'function') {
        onSuccess.call(context, response)
      }
    } else {
      context.error = response.data.error || 'Unable to receive data from the server. Please reload the page.'
    }
  } catch (error) {
    if (error.response && error.response.data) {
      context.error = error.response.data.error || 'Unknown server error'
    } else {
      context.error = error.message || 'Unable to receive data from the server.'
    }
  } finally {
    if (context) {
      context.options = context.options || {}
      context.options.loaded = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/apiHelpers.js